<script setup>
  import ListeAffairesSoldees from '@/components/ListeAffairesSoldees.vue'

</script>

<template>
  <h1>Liste des affaires soldées</h1>
  <div class="affaires">
    <ListeAffairesSoldees/>
  </div>
</template>

<script>


export default {

}
</script>

<style>


</style>
